import actionBuilder from 'store/v2/actions';
import actionType, { bulkActionType, apiPath } from './constants';

// MUWAHAHAHAHAHAHAHA
const actions = {
  ...actionBuilder({ apiPath, bulkActionType, actionType }),
};

export default actions;
